export default "__VITE_ASSET__d0LZ7dCX__"